import { formatedDate } from '../Functions/convertDate';
import { formatedNumber } from '../Functions/convertNumber';

export const HandlePrint = async(factures) => {

  console.log("factures",factures);
  const { clients, consommations, logements } = factures[0]; 
  const printWindow = window.open('', '_blank');
  const generateRowsHTML = (rows, formatter) => rows.map(formatter).join('');
  const clientRowFormatter = (client) => `
    <tr>
      <td class="td-x-large">${client.passport}</td>
      <td>${client.clientName}</td>
      <td class="td-large">${formatedDate(client.clientCheckIn)}</td>
      <td class="td-large">${formatedDate(client.clientCheckOut)}</td>
    </tr>`;
  const clientRowsHTML = generateRowsHTML(clients, clientRowFormatter);

  const consommationRowFormatter = (consommations) => `
    <tr>
      <td class="td-x-large">${formatedDate(consommations.enterDate)}</td>
      <td class="td-x-large">${formatedDate(consommations.sortDate)}</td>
      <td>${consommations.description}</td>
      <td class="td-small">${formatedNumber(consommations.unitPrice)}</td>
      <td class="td-smallest1">${consommations.quantiteConsom}</td>
      <td class="td-large">${formatedNumber(consommations.totalConsom)}</td>
    </tr>`;
  const consommationRowsHTML = generateRowsHTML(consommations, consommationRowFormatter);
  console.log("logementssssssssss",logements);
  const logementRowFormatter = (logements) => `
    <tr>
      <td>${logements.typeChambre}</td>
      <td>${logements.prixtype}</td>
      <td>${logements.pension}</td>
      <td class="td-small">${formatedDate(logements.checkIn)}</td>
      <td class="td-small">${formatedDate(logements.checkOut)}</td>
      <td class="td-small">${formatedNumber(logements.prixChambre)}</td>
      <td class="td-smallest">${logements.quantite}</td>
      <td class="td-large">${formatedNumber(logements.totalLoge)}</td>
    </tr>`;
  const logementRowsHTML = generateRowsHTML(logements, logementRowFormatter);
  const styles = `
    .handlePrint__body { font-family: Arial, sans-serif; margin: 20px; direction: rtl; font-size: 12px; }
    .handlePrint__body h1 { margin-bottom: 10px; margin-top: 110px; }
    .handlePrint__body h2 { margin-bottom: 10px; }
    table { width: 100%; border-collapse: collapse; margin: 10px 0; }
    .handlePrint__body th, td { border: 1px solid #000000; padding: 3px; text-align: right; font-size: 12px; }
    .handlePrint__body th { background-color:rgb(226, 226, 226); font-weight: bold; }
    .summary-table-3 { 
      width: 55%; 
      float: left; /* Align the table to the right */
      margin-right: auto; /* Push it to the right margin */
      margin-left: 0; /* Ensure there's no space on the right */
      padding-bottom: 0;
      margin-bottom: 0;
    }

    .background_color{ background-color:rgb(226, 226, 226); }

    .summary-table-2 { 
      width: 65%; 
      float: left; /* Align the table to the right */
      margin-right: auto; /* Push it to the right margin */
      margin-left: 0; /* Ensure there's no space on the right */
      padding-top: 0;
      margin-top: 0;
    }


    .summary-table { 
      width: 55%; 
      float: left; /* Align the table to the right */
    }

    .bold { font-weight: bold; }
    .large { font-size: 25px; }
    .center { text-align: center;}
    .bold-border { border: 2px solid #000000; }
    .Bold-border-top { border-top: 2px solid #000000; /* 2px solid on top */ }
    .Bold-border-bottom { border-bottom: 2px solid #000000; /* 2px solid on top */ }
    .Bold-border-left { border-left: 2px solid #000000; /* 2px solid on top */ }
    .Bold-border-right { border-right: 2px solid #000000; /* 2px solid on top */ }
    .line-width { width: 100px }
    .line-width-large { width: 100% }

    .td-smallest{width: 3%;}
    .td-smallest1{width: 2%;}
    .td-small{width: 13%;}
    .td-middle{width: 15%;}
    .td-large{width: 16%;}
    .td-x-large{width: 20%;}
    .td-xll-large{width: 21%;}
    .td-xl-large{width: 24%;}
    .td-xx-large{width: 31%;}
  `;

  const htmlTemplate = `
    <html>
      <head>
        <title>فاتورة</title>
        <style>${styles}</style>
      </head>
      <body class="handlePrint__body">
        <h1>فاتورة</h1>
        <table class="header-table">
          <tr>
            <td class="td-x-large Bold-border-top Bold-border-right">رقم الفاتورة</td>
            <td class="td-small Bold-border-top">${factures[0].id_facture}</td>
            <td rowspan="3" class="bold large center Bold-border-left Bold-border-top Bold-border-bottom">${factures[0].selectedorganisme}</td>
          </tr>
          <tr>
            <td class="Bold-border-right">${factures[0].selectedHotel}</td>
            <td>${factures[0].nbrfact}</td>
          </tr>
          <tr>
            <td class="Bold-border-bottom Bold-border-right">التاريخ</td>
            <td class="Bold-border-bottom">${formatedDate(factures[0].currentDate)}</td>
          </tr>
        </table>

        <h2>الحرفاء</h2>
        <table>
          <thead>
            <tr>
              <th>رقم جواز السفر</th>
              <th>اسم الحريف</th>
              <th>تاريخ الدخول</th>
              <th>تاريخ المغادرة</th>
            </tr>
          </thead>
          <tbody>${clientRowsHTML}</tbody>
        </table>

        <h2>الإقامة</h2>
        <table>
          <thead>
            <tr>
              <th>نوع الغرفة</th>
              <th>الصنف</th>
              <th>نوع الإقامة</th>
              <th>تاريخ الدخول</th>
              <th>تاريخ المغادرة</th>
              <th>السعر الفردي</th>
              <th>الكمية</th>
              <th>المجموع</th>
            </tr>
          </thead>
          <tbody>${logementRowsHTML}</tbody>
        </table>

        ${consommations && consommations.length > 0 ? `
          <h2>الإضافات</h2>
          <table>
            <thead>
              <tr>
                <th>تاريخ الدخول</th>
                <th>تاريخ المغادرة</th>
                <th>الوصف</th>
                <th>معدل السعر</th>
                <th>الكمية</th>
                <th>المجموع</th>
              </tr>
            </thead>
            <tbody>${consommationRowsHTML}</tbody>
          </table>
        ` : ''}

        <table class="summary-table-3">
          <tr class="bold background_color"><td class="Bold-border-top Bold-border-right">المجموع</td><td class="td-xl-large Bold-border-top Bold-border-left">${formatedNumber(factures[0].totalFacture)}</td></tr>
          <tr><td class="Bold-border-right">عمولة ${factures[0].commissionRate}%</td><td class="Bold-border-left">${formatedNumber(factures[0].commission)}</td></tr>
          <tr><td class="Bold-border-right">القيمة المضافة على العمولة 19 %</td><td class="Bold-border-left">${formatedNumber(factures[0].comtax)}</td></tr>
          ${factures[0].tva && factures[0].tva !== 0 ? `
            <tr>
              <td class="Bold-border-right">ظريبة الاقامة</td>
              <td class="Bold-border-left">${formatedNumber(factures[0].tva)}</td>
            </tr>
            ` : ''}
          <tr><td class="Bold-border-right">الطابع الجبائي</td><td class="Bold-border-left">${formatedNumber(factures[0].timbre)}</td></tr>
        </table>

        <table class="summary-table-2">
           <tr class="bold Bold-border background_color"><td class="center">المبلغ المطلوب</td><td class="td-x-large">${formatedNumber(factures[0].solde)}</td></tr>
        </table>


      </body>
    </html>
  `;
  printWindow.document.write(htmlTemplate);
  printWindow.document.close();
  printWindow.focus();
  printWindow.print();
  printWindow.close();
};
